import { useEffect, useState } from 'react'

import { IShotlist } from '@/types/shotlist.interface'

import { TFileLeftTab, getNextFileTabs } from '../helpers/getNextFileTabs'

interface IUseFileTabsParams {
	shotlist?: IShotlist
	isTranslateLoading: boolean
	lastTranslateTargetLang?: string
}

export const useFileTabs = ({
	shotlist,
	isTranslateLoading,
	lastTranslateTargetLang
}: IUseFileTabsParams) => {
	const [leftTab, setLeftTab] = useState<TFileLeftTab>('original')
	const [rightTab, setRightTab] = useState<string | null>(null)

	useEffect(() => {
		if (!shotlist) return

		const nextTabs = getNextFileTabs({
			leftTab,
			rightTab,
			translationLanguages: shotlist.translations.map(t => t.language),
			isTranslateLoading,
			lastTranslateTargetLang
		})

		if (nextTabs.leftTab !== leftTab) {
			setLeftTab(nextTabs.leftTab)
		}

		if (nextTabs.rightTab !== rightTab) {
			setRightTab(nextTabs.rightTab)
		}
	}, [shotlist, leftTab, rightTab, isTranslateLoading, lastTranslateTargetLang])

	return {
		leftTab,
		rightTab,
		setLeftTab,
		setRightTab
	}
}
